import {DOCUMENT} from '@angular/common';
import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {environment} from '../environments/environment';
import {User} from './models/user.interface';
import {DeviceService} from './services/device.service';
import {changeOrganization} from './store/organizations/actions/change-organization.actions';
import {getCurrentUserRecord} from './store/users/selectors/current-user.selectors';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppLayoutComponent {
  currentUser$: Observable<User>;
  device$: Observable<string>;

  constructor(
    private deviceService: DeviceService,
    private store: Store,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.currentUser$ = this.store.select(getCurrentUserRecord);
    this.device$ = this.deviceService.getDevice();
    this.setGA();
  }

  public onActivate(): void {
    this.document.querySelector('mat-sidenav-content').scrollTo(0, 0);
  }

  public chooseOrganization(organizationId: number): void {
    this.store.dispatch(changeOrganization({data: {organizationId: organizationId}}));
  }

  private setGA(): void {
    if (environment.env === 'prod') {
      const head = this.document.getElementsByTagName('head')[0];
      const s = this.document.createElement('script');
      s.type = 'text/javascript';
      s.src = 'https://www.googletagmanager.com/gtag/js?id=G-YPTK4501VY';
      head.appendChild(s);

      const s2 = this.document.createElement('script');
      s2.type = 'text/javascript';
      s2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-YPTK4501VY');
    `;
      head.appendChild(s2);
    }
  }
}

